import React from 'react';
import { useDispatch } from 'react-redux';
import * as CalendarActions from '../../actions/calendar';
import Svg from '../shared/Svg';
import PropTypes from 'prop-types';
import './MatchingContacts.scss';

export const MatchingContacts = ({ email, contactList, isOrganizer }) => {
  const dispatch = useDispatch();

  const setAssociatingAttendee = () => {
    dispatch(CalendarActions.multiMatchAttendeeFixed());
    dispatch(CalendarActions.associateAttendee({
      email,
      contactList,
      isOrganizer,
    }));
  };

  return (
    <div className='matchingContacts-container'>
      { isOrganizer &&
        <Svg className='matchingContacts-image' data='/assets/people.svg'/>
      }
      <div className='matchingContacts-details'>
        <h2>{contactList.length} Matching { isOrganizer ? 'Users' : 'Attendees' } Found { isOrganizer && <span>(Assigned To)</span> }</h2>
        <p>{email}</p>
      </div>
      <Svg
        data='/assets/chevronright.svg'
        className='matchingContacts-chevron'
        fill='#706E6B'
        onClickAction={setAssociatingAttendee}
      />
    </div>
  );
};

MatchingContacts.propTypes = {
  email: PropTypes.string,
  contactList: PropTypes.arrayOf(PropTypes.object),
  isOrganizer: PropTypes.bool,
};
